import styled from "@emotion/styled"

import Creatable from "react-select/creatable"
import NewBoxButton from "../Radiate/NewBoxButton/NewBoxButton"

export const InnerMemberContainer = styled.div`
  height: 100%;
  padding: 16px;
  display: flex;
  flex-direction: column;
  color: ${(props) => props.theme.gray7};
  overflow-y: scroll;


  ::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */

  .member-email {
    margin: 8px 0;
  }
`

export const TextM = styled.div`
  padding-top: 8px;
  font-size: ${(props) => props.theme.textMd};
  display: flex;
  text-align: center;
  font-weight: ${(props) => props.memberName && "600"};
`

export const TextS = styled.div`
  padding-top: 8px;
  font-size: ${(props) => props.theme.textSm};
  display: flex;
  text-align: center;
  font-weight: ${(props) => props.memberName && "600"};
`

export const StyledCreatable = styled(Creatable)`
  width: 100%;
  margin-top: 2px;

`

export const TagsContainer = styled.div`
  width: 100%;
  border-top: 1px solid ${(props) => props.theme.gray1};
  border-bottom: 1px solid ${(props) => props.theme.gray1};
  padding: 28px 0;

  .title-container {
    padding-bottom: 4px;
    display: flex;
    align-items: center;
    .title {
      font-weight: bold;
      font-size: ${(props) => props.theme.textSm};
    }

    .error {
      font-size: ${(props) => props.theme.textSm};
      color: ${(props) => props.theme.error};
    }
  }


`
export const NotesContainer = styled.div`
  width: 100%;
  padding: 16px 0;

  >.title-container {
    >.title {
      font-weight: bold;
      font-size: ${(props) => props.theme.textSm};
    }
  }
`

export const NoteContainer = styled.div`
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  margin: 16px;
  padding: ${(props) => {
    if (props.isWrittenByMe) {
      return "8px 12px" 
    }
    return "25px 12px 8px 12px"
    }
  };

  &:last-child {
    border-bottom: none;
  }

  >.buttons-container {
    display: flex;
    justify-content: flex-end;
    padding-bottom: 8px;

    .save-button {
      margin-left: 8px;
    }
  }

  .content {
    color: ${props => props.theme.gray9};
    font-size: ${(props) => props.theme.textSm};
    white-space: pre-wrap;
    word-break: break-word;
    line-height: 1.3;
  }

  .author {
    font-size: 0.7rem;
    line-height: 34px;
  }
`

export const EditButton = styled(NewBoxButton)`
  position: absolute ;
  right: -12px;
  top: -8px;
`

export const MemberInfo = styled.div`
  padding-bottom: 16px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;

  >.edit-dropdown-button {
    position: absolute ;
    right: -12px;
    top: -8px;
  }
`

export const CloseMemberInfoButton = styled(NewBoxButton)`
  position: absolute ;
  left: -12px;
  top: -8px;
`

export const EmailRow = styled.tr`
  display: flex;
  align-items: center;
  font-size: ${(props) => props.theme.textSm};
  padding-bottom: 4px;
  cursor: pointer;

  &:last-child {
    padding-bottom: 0px;
  }

  >.icon {
    padding-right: 8px;
  }

`

export const ChannelRow = styled.div`
  display: flex;
  align-items: center;
  font-size: ${(props) => props.theme.textSm};

  .channel-name {
    padding-left: 4px;
  }
`

export const ChannelNameAndExternalIdWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const MembersContainer = styled.div`
  width: 100%;
  border-top: 1px solid ${(props) => props.theme.gray1};
  margin-top: 16px;
`

export const MembersHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  border-radius: 6px;
  
  .left-section {
    display: flex;
    align-items: center;
    gap: 12px;
    cursor: pointer;
    padding: 4px 8px;
    border-radius: 4px;
    transition: background-color 0.2s ease;
    
    &:hover {
      background-color: ${(props) => props.theme.gray0};
    }
    
    .group-icon {
      color: ${(props) => props.theme.gray6};
      font-size: 16px;
    }
    
    .title {
      font-weight: 600;
      font-size: ${(props) => props.theme.textSm};
      color: ${(props) => props.theme.gray8};
    }
    
    .add-member {
      display: flex;
      align-items: center;
      gap: 8px;
      color: ${(props) => props.theme.primary};
      font-size: ${(props) => props.theme.textSm};
      font-weight: 500;
      padding: 4px 8px;
      border-radius: 4px;
      transition: background-color 0.2s ease;
      
      &:hover {
        background-color: ${(props) => props.theme.primaryLight}20;
      }
      
      svg {
        font-size: 12px;
      }
      
      span {
        color: ${(props) => props.theme.primary};
      }
    }
  }
  
  .chevron-icon {
    color: ${(props) => props.theme.gray5};
    transition: transform 0.2s ease;
    transform: ${(props) => props.isExpanded ? 'rotate(180deg)' : 'rotate(0deg)'};
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    
    &:hover {
      background-color: ${(props) => props.theme.gray0};
    }
  }
`

export const MembersContent = styled.div`
  transition: all 0.3s ease;
`

export const GroupMembersIframe = styled.iframe`
  width: 100%;
  border: none;
  border-radius: 8px;
  background-color: ${(props) => props.theme.gray0};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: height 0.3s ease;
`

export const MembersActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  margin-bottom: 8px;
`

export const InviteLink = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  ${'' /* padding: 12px 16px; */}
  background-color: ${(props) => props.theme.gray0};
  ${'' /* border-radius: 8px; */}
  margin-bottom: 8px;
  ${'' /* border: 1px solid ${(props) => props.theme.gray2};s */}
  
  svg {
    color: ${(props) => props.theme.gray5};
    font-size: 16px;
    flex-shrink: 0;
  }
  
  .invite-text {
    font-size: ${(props) => props.theme.textXs};
    color: ${(props) => props.theme.primary};
    font-weight: 500;
    word-break: break-all;
    text-decoration: underline;
    cursor: pointer;
    
    &:hover {
      opacity: 0.8;
    }
  }
`

export const SearchIcon = styled.div`
  color: ${(props) => props.theme.gray5};
  cursor: pointer;
  padding: 4px;
  
  &:hover {
    color: ${(props) => props.theme.gray7};
  }
`

export const MemberRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 12px;
  background-color: ${(props) => props.theme.gray1};
  padding: 8px 12px;
  border-radius: 6px;
  
  .member-info {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
    
    
    .member-details {
      display: flex;
      flex-direction: column;
      gap: 2px;
      
      .member-name {
        font-size: ${(props) => props.theme.textSm};
        color: ${(props) => props.theme.gray8};
        font-weight: 500;
      }
      
      .member-subtitle {
        font-size: ${(props) => props.theme.textXs};
        color: ${(props) => props.theme.gray5};
      }
    }
  }
  
  .member-status {
    font-size: ${(props) => props.theme.textXs};
    background-color: ${(props) => props.theme.success || '#10B981'};
    color: white;
    padding: 6px 12px;
    border-radius: 16px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    white-space: nowrap;
  }
`

export const DeleteGroupButton = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${(props) => props.theme.error};
  font-size: ${(props) => props.theme.textSm};
  cursor: pointer;
  padding: 12px 0;
  margin-top: 16px;
  border-top: 1px solid ${(props) => props.theme.gray1};
  
  &:hover {
    opacity: 0.8;
  }
  
  .delete-icon {
    font-size: 14px;
  }
`
